import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllContractor = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_CONTRACTORS, token)
  return res;
};

export const getContractorDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_CONTRACTOR_DETAILS}/${id}`, token)
  return res;
};

export const addContractor = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_CONTRACTOR, payload, token)
  return res;
};

export const updateContractor = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_CONTRACTOR}/${id}`, payload, token)
  return res;
};

export const deleteContractorByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_CONTRACTOR}/${id}`, {}, token)
  return res;
};

export const updateContractorProfile = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_CONTRACTOR_PROFILE}/${id}`, payload, token)
  return res;
};

export const uploadContractorImage = async(id, formData) => {
  let token = localStorage.getItem("token");
  let res = await Services.UPLOAD(`${Url.UPLOAD_CONTRACTOR_IMAGE}/${id}`, formData, token)
  return res;
};
